var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1042 3.48759C12.4215 3.17044 12.5997 2.74026 12.5998 2.29168C12.5998 1.8431 12.4217 1.41287 12.1045 1.09564C11.7874 0.778405 11.3572 0.600154 10.9086 0.600098C10.46 0.600041 10.0298 0.778185 9.71258 1.09534L1.7048 9.10492C1.56548 9.24382 1.46246 9.41485 1.40479 9.60293L0.61217 12.2142C0.596663 12.2661 0.595492 12.3212 0.608781 12.3737C0.62207 12.4262 0.649323 12.4741 0.68765 12.5124C0.725976 12.5507 0.773946 12.5778 0.82647 12.591C0.878994 12.6042 0.934113 12.603 0.985979 12.5874L3.59784 11.7954C3.78574 11.7382 3.95675 11.6358 4.09585 11.4972L12.1042 3.48759Z",
    stroke: "#714FFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39648 2.40088L10.7965 4.80093",
    stroke: "#714FFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.d7e223b41a60030c327568e43bc6b5ac.svg";
export { ForwardRef as ReactComponent };